import { SessionService } from './../../services/session.service';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';


declare var jQuery: any;
declare var $: any;
declare var Faqs: any;

@Component({
    selector: 'app-faqSoria',
    templateUrl: './faqSoria.component.html'
})


export class FaqSoriaComponent implements OnInit {

    public title: string;

    constructor(public router: Router, public sessionService: SessionService) { }

    ngOnInit() {
      Faqs.init();
    }

    public Volver() {
        if (this.sessionService.contratos !== undefined) {
            this.router.navigate(['/home/home']);
        } else {
            this.router.navigate(['/public/login']);
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/Faqs/faqSoria.component.ts